import { getIoaCookieToken, setCookieToken, VISITOR_TOKEN } from '.';
import { ioaLogin } from '../../../api/user';
import { getConfig } from '../../../config';
import { getLocationSearchParam, replaceURL } from '../../../lib';
import { DeployArea } from '../../../model';

export const checkIoaLogin = async (history: any) => {
  const { deployArea } = getConfig();
  if (deployArea !== DeployArea.woa) {
    return;
  }
  const ticket = getIoaCookieToken();
  if (ticket) {
    return;
  }

  const ioaCode = getLocationSearchParam('code') || '';
  if (!ioaCode) {
    jumpToIoaLogin();
    return;
  }

  const res = await ioaLogin(ioaCode);
  if (!res) {
    setCookieToken(VISITOR_TOKEN);
    window.history.pushState({}, document.title, location.origin);
    return false;
  }
  setCookieToken(res.emailTicket);
  history.push('/');
  // replaceURL(location.origin);
};

export const jumpToIoaLogin = () => {
  const { ioaLoginConfig } = getConfig();
  if (!ioaLoginConfig) {
    return;
  }
  const url = `${ioaLoginConfig.loginURL}&url=${encodeURI(location.href)}`;
  replaceURL(url);
};
